import { RootState } from "..";

export const selectSubscriptionPackages = (state:RootState) => state.subscriptions.subscriptionPackages;
